
/*eslint-disable*/
import React from "react";

// reactstrap components
import { Col, Row } from "reactstrap";

function OutFooter(props) {
  return (
    <footer className="footer" style={{ textAlign: "right" ,    padding: '24px 0'}}>
      <Row style={{ padding: "20px 40px 20px 40px",marginLeft: '0'}}>

        <Col md="12">
          <Col md="2" xs="12" sm="3" className="footer-menu">
            <h4>لینک های مرتبط</h4>
            <ul style={{ listStyle: "none", marginRight: "-40px" }}>
              <li className="whiteColor"><a className="whiteColor" href="https://irandehyar.com/" target="_blank">  ایران دهیار</a></li>
              <li className="whiteColor"><a className="whiteColor" href="https://trez.ir/" target="_blank">  شرکت ترز رایان</a></li>
              <li className="whiteColor"><a className="whiteColor" href="https://sms.trez.ir/" target="_blank">  سامانه پیامک ترز</a></li>
              <li className="whiteColor"><a className="whiteColor" href="https://raygansms.com/" target="_blank">  پنل اس ام اس</a></li>
            </ul>
          </Col>
          <Col md="3" xs="12" sm="3">
            <h4>برچسب ها</h4>
            <ul id="tagsList" style={{ listStyle: "none", marginRight: "-40px" }}>
              <li ><a className="whiteColor" href="/">پرداخت عوارض</a></li>
              <li ><a className="whiteColor" href="/">پرداخت آنلاین عوارض</a></li>
              <li ><a className="whiteColor" href="/">صدور عوارض</a></li>
              <li ><a className="whiteColor" href="/">عوارض روستایی</a></li>
            </ul>
          </Col>

          {/* <Col md="4" xs="12" sm="3">
            <h4>اطلاعات تماس</h4>
            <ul style={{ listStyle: "none", marginRight: "-40px" }}>
              <li className="whiteColor"><i className="fa fa-map-marker"></i>  {props.siteSetting.DehyariAddress ?? "  [وارد نشده]"}</li>
              <li className="whiteColor"><i className="fa fa-phone"></i><a style={{ color: "white" }} href={"tel:" + props.siteSetting.DehyariPhoneNumber}>  {props.siteSetting.DehyariPhoneNumber}</a></li>
              <li className="whiteColor"><i className="fa fa-envelope"></i>  {props.siteSetting.DehyariEmail ?? "  [وارد نشده]"}</li>
            </ul>
          </Col> */}

          <Col md="3" xs="12" sm="3">
            <div id="logo-div-footer" className="col-sm-12 text-center">
     {/*          <img src={require("../../assets/img/logo.png").default}></img> */}
               <div dangerouslySetInnerHTML={{__html: props.siteSetting.Enamad}} />

            </div>
          </Col>
        </Col>
        <Col md="12" className="footer_copyright">
          <span>طراحی شده توسط 
          <a href="https://trez.ir/" target="_blank"> شرکت ترز رایان افزار </a>
          </span>
        </Col>
      </Row>
    </footer>
  );
}

export default OutFooter;
